import { breakpoints } from './breakpoints'

export const mediaQueries = {
  smallScreen: `screen and (max-width: ${breakpoints.breakMedium})`,
  mediumScreen: `screen and (max-width: ${breakpoints.breakLarge})`,
  largeScreen: `screen and (min-width: ${breakpoints.breakLarge})`,
  notMobile: `screen and (min-width: ${breakpoints.breakMedium})`,
}
